import { useDtfStore } from "../store";
import { cn } from "tailwind-variants";
import "./UploadGangSheet.scss";

export default function UploadGangSheet({ currentStore, ...restProps }) {
  const store = useDtfStore();

  function gangSheetBuilderSettings() {
    return store.gangSheetBuilderSettings;
  }

  function gangSheetBuilderVariants() {
    return store.gangSheetBuilderVariants;
  }

  function variantUrl() {
    const variantObj = Object.values(gangSheetBuilderVariants()).find(
      variant => variant.variant_id === gangSheetBuilderSettings().variantId
    );
    return currentStore === "ca"
      ? `/${currentStore}/${variantObj.product_slug}.html`
      : `/${variantObj.product_slug}.html`;
  }

  return (
    <div {...restProps} className={cn("gang-sheet-builder-upload", restProps.className)}>
      {" "}
      Have a print-ready file?{" "}
      <a
        className="gang-sheet-builder-upload__link"
        href={variantUrl()}
        data-testid="gang-sheet-builder-upload-link"
      >
        {" "}
        Upload Your Gang Sheet{" "}
      </a>
    </div>
  );
}
